import React from "react";
import AuthPageComponents from "../components/page-auth/AuthPageComponents";
import PublicLayout from "../layouts/PublicLayout";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import RegistrationPageComponents from "../components/page-auth/RegistrationPageComponents";
import RequestPasswordPageComponents from "../components/page-auth/RequestPasswordPageComponents";
import TermsAndConditionsPageComponents from "../components/page-auth/TermsAndConditionsPageComponents";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            marginBottom: 80
        }
    })
);

export const AUTH_PAGE_MENU = {
    REGISTER: "register",
    RESET_PASSWORD: "reset-password",
    TERMS_AND_CONDITIONS: "terms-and-conditions"
};

function AuthPage() {
    const classes = useStyles();
    const {search} = useLocation();
    const {menu} = queryString.parse(search);
    const {t} = useTranslation();

    let title = t(menu ? "page.title." + menu : "page.title.login");

    let headerTitle = "";
    if (menu === AUTH_PAGE_MENU.TERMS_AND_CONDITIONS) {
        headerTitle = t("page.title.terms-and-conditions-header");
    }

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{title}</title>
                <meta name="description" content={title}/>
            </Helmet>

            <div className={classes.root}>
                <PublicLayout pageTitle={headerTitle}>
                    {(() => {
                        switch (menu) {
                            case AUTH_PAGE_MENU.REGISTER:
                                return <RegistrationPageComponents/>;
                            case AUTH_PAGE_MENU.RESET_PASSWORD:
                                return <RequestPasswordPageComponents/>;
                            case AUTH_PAGE_MENU.TERMS_AND_CONDITIONS:
                                return <TermsAndConditionsPageComponents/>;
                            default:
                                return <AuthPageComponents/>
                        }
                    })()}
                </PublicLayout>
            </div>
        </AuthorizedContextProvider>
    );
}

export default AuthPage;
